import React, { useContext } from "react"
import { ScrollView, Text, View } from "react-native"
import { textStyles } from "../style"
import { ThemeContext } from "../utility/context/ThemeContext"
import { useAppSelector } from "../store"
import SuccessAnimation from "../utility/success-animation"

const OnboardingComplete = () => {
  const theme = useContext(ThemeContext).theme
  const { textMain } = theme.colors

  const { user } = useAppSelector((state) => state.auth)

  return (
    <ScrollView style={{flex: 1}} contentContainerStyle={{gap: 20}}>
      <View style={{alignItems: "center"}}>
        <SuccessAnimation size={150} />
      </View>
      <Text style={[textStyles.body, {color: textMain}]}>
        Congratulations {user.firstName}! You have successfully completed the onboarding process.
      </Text>
      <Text style={[textStyles.body, {color: textMain}]}>
        You are now equipped with the tools to track the votes you cast with every dollar you spend{' '}
        and are joining a community of like-minded, mission-driven individuals who are committed{' '}
        to making a positive impact on the world.
      </Text>
      <Text style={[textStyles.body, {color: textMain}]}>
        Be sure to spread the word and invite your friends and family to join Impact Banking to{' '}
        amplify your impact and make a difference together!
      </Text>
    </ScrollView>
  )
}

export default OnboardingComplete